module.exports = __webpack_public_path__ + "img/project-4.f03637c4.jpg";